import { render, staticRenderFns } from "./inheritSuccess.vue?vue&type=template&id=128c232e&scoped=true&"
import script from "./inheritSuccess.vue?vue&type=script&lang=js&"
export * from "./inheritSuccess.vue?vue&type=script&lang=js&"
import style0 from "./inheritSuccess.vue?vue&type=style&index=0&id=128c232e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128c232e",
  null
  
)

export default component.exports